import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { money, StatusBadge } from "@/components/payments/PaymentHistory";
import { api, errMsg } from "@/lib/api";

export const AdminPayments = () => {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/admin/payments").then((r) => setRows(r.data.payments)).catch((e) => { toast.error(errMsg(e)); setRows([]); }); }, []);
  const refund = async (p) => {
    if (!window.confirm(`Refund ${money(p.amount, p.currency)} to ${p.user_email}? The plan's credits and days will be removed.`)) return;
    setBusy(p.order_id);
    try {
      const { data } = await api.post(`/admin/payments/${p.order_id}/refund`);
      setRows((rs) => rs.map((r) => (r.order_id === p.order_id ? { ...r, ...data } : r)));
      toast.success("Refund issued.");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy("");
    }
  };
  return (
    <section className="panel p-6" data-testid="admin-payments">
      <h2 className="text-lg font-semibold mb-4">Transactions</h2>
      {!rows && <Loader2 className="h-5 w-5 animate-spin text-primary" />}
      {rows?.length === 0 && <p className="text-sm text-muted-foreground">No transactions yet.</p>}
      {rows?.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-xs text-muted-foreground"><tr><th className="py-2">Date</th><th>User</th><th>Plan</th><th>Amount</th><th>Provider</th><th>Status</th><th /></tr></thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.order_id} className="border-t border-border" data-testid={`admin-payment-${p.order_id}`}>
                  <td className="py-2">{new Date(p.created_at).toLocaleDateString()}</td>
                  <td>{p.user_email}{p.transaction_id && <div className="text-[10px] font-mono text-muted-foreground">{p.transaction_id}</div>}</td>
                  <td>{p.plan_name}</td>
                  <td>{money(p.amount, p.currency)}{p.test_mode && <span className="ml-1 text-[11px] text-amber-400">test</span>}</td>
                  <td className="capitalize">{p.provider}</td>
                  <td><StatusBadge status={p.status} /></td>
                  <td className="text-right">
                    {p.status === "paid" && (
                      <button data-testid={`admin-refund-${p.order_id}`} onClick={() => refund(p)} disabled={busy === p.order_id} className="text-xs font-semibold text-rose-400 disabled:opacity-40">
                        {busy === p.order_id ? "Refunding…" : "Refund"}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
